(function ($, Drupal) {
  'use strict';
  /**
 * Culture - Feature Carousel - v1
 */

  var cultureFeatureCarouselFormatterV1 = {
    formatter: $('.culture-feature-carousel-formatter-v1'),
    autoplaySpeed: 3000,
    transitionSpeed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
  };

  Drupal.behaviors.cultureFeatureCarouselFormatterV1 = {
    get: function (key) {
      return cultureFeatureCarouselFormatterV1[key];
    },

    set: function (key, val) {
      cultureFeatureCarouselFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var carousel = thisFormatter.find('> ul');
        var slide = '.carousel-slide';
        var autoplaySpeed = self.get('autoplaySpeed');
        var speed = self.get('transitionSpeed');
        var slidesToShow = self.get('slidesToShow');
        var slidesToScroll = self.get('slidesToScroll');
        var fade = self.get('fade');
        var appendArrows = thisFormatter.find('.culture-feature__carousel-controls');
        var count = appendArrows.find('.count');
        var items = carousel.find(slide).length;
        var autoplay = carousel.attr('data-slides-autoplay');

        if (typeof autoplay == 'undefined') {
          autoplay = false;
        } else {
          autoplay = true;
        }

        if (items === 1) {
          appendArrows.hide();
        }

        var isRTL = site.direction.isRTL && Drupal?.settings?.forceSlickRTL;
        // swipe/drag direction is opposite when in RTL
        // so better to just disable it until a fix is provided in the library
        var swipe = isRTL ? false : true;
        var draggable = swipe;

        carousel.slick({
          rtl: isRTL,
      	swipe: swipe,
      	draggable: draggable,
          appendArrows: appendArrows,
          autoplay: autoplay,
          autoplaySpeed: autoplaySpeed,
          fade: fade,
          slide: slide,
          accessibility: true,
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToScroll,
          speed: speed,
          onInit: function () {
            count.html('1/' + items);
          },
          onAfterChange: function () {
            var currentSlide = carousel.slickCurrentSlide() + 1;

            count.html(currentSlide + '/' + items);
          }
        });
      });
    }
  };
})(jQuery, Drupal);
